import type { InjectionKey } from 'vue'

export const chromaticHue: InjectionKey<number> = Symbol('@meowchat/chromatic-hue')
